var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainSectionRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 172,
    viewBox: "0 0 173 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 86,
    r: 86,
    fill: "white",
    fillOpacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5009,
    cy: 86.0009,
    r: 72.9697,
    fill: "white",
    fillOpacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.6541,
    cy: 85.9998,
    r: 7.81818,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.8748 53.3322C85.9965 51.2831 82.9384 51.2831 81.0601 53.3322C79.1967 55.3649 79.1967 58.65 81.0601 60.6828L104.566 86.3256L81.0601 111.969C79.1967 114.001 79.1967 117.286 81.0601 119.319C82.9384 121.368 85.9965 121.368 87.8748 119.319L114.75 90.0009C116.613 87.9682 116.613 84.6831 114.75 82.6503L87.8748 53.3322Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.651515,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainSectionRightArrow);
export default __webpack_public_path__ + "static/media/MainSectionRightArrow.544a078879f0a8d9eb5d55a0cfbbd648.svg";
export { ForwardRef as ReactComponent };